// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Router from "next/router";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as AuthUtils$PorterinFeature from "../../../domain/helpers/AuthUtils.mjs";
import * as AuthTextCmp$PorterinFeature from "../common/AuthTextCmp.mjs";
import * as AuthContextV1$PorterinFeature from "../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as SignupFormCmp$PorterinFeature from "./form/SignupFormCmp.mjs";
import * as CategoryAnalytics$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/CategoryAnalytics.mjs";
import * as AuthWrapperModuleScss from "../../styles/AuthWrapper.module.scss";
import * as CommonAnalyticsHelper$PorterinFeature from "../../../../../shared/core/helpers/CommonAnalyticsHelper.mjs";
import * as FareEstimateAnalyticsHelper$PorterinFeature from "../../../../fare-estimate-v1/domain/helpers/FareEstimateAnalyticsHelper.mjs";

var styles = AuthWrapperModuleScss;

function SignupCmp(Props) {
  var set_auth_state = Props.set_auth_state;
  var prefill = Props.prefill;
  var router = Router.useRouter();
  var match = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var user = match.user;
  React.useEffect((function () {
          var timeout_id = setTimeout((function (param) {
                  CommonAnalyticsHelper$PorterinFeature.publishPageLandEventWithParameter(CategoryAnalytics$PorterinFeature.getCategoryName(router), AuthStore$PorterinFeature.Signup.ga_page_landing, AuthStore$PorterinFeature.Signup.moe_page_landing_parameter, FareEstimateAnalyticsHelper$PorterinFeature.getFareSelectedCardVersionEventPayload(AuthUtils$PorterinFeature.mobile(user)));
                }), 0);
          return (function (param) {
                    clearTimeout(timeout_id);
                  });
        }), []);
  return React.createElement("div", {
              className: styles.wrapper
            }, React.createElement(AuthTextCmp$PorterinFeature.make, {
                  heading: AuthStore$PorterinFeature.Signup.signup_heading,
                  sub_heading: undefined
                }), React.createElement("p", {
                  className: styles["signup-subheading"]
                }, AuthStore$PorterinFeature.Signup.signup_subheading), React.createElement(SignupFormCmp$PorterinFeature.make, {
                  set_auth_state: set_auth_state,
                  prefill: prefill
                }));
}

var make = SignupCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
